// UpdatePostPage.tsx
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { PostFormData, Post } from "../../../types/features/Post";
import usePosts from "../../../hooks/features/posts/usePosts";
import PostForm from "../../../components/shared/blog/posts/PostForm";
import PageLayout from "../../../layouts/PageLayout";
import PageContainer from "../../../components/ui/PageContainer";
import useCustomParams from "../../../hooks/core/useCustomParams";

export default function UpdatePostPage() {
  const { id } = useCustomParams();
  const navigate = useNavigate();
  const { fetchPostById, updatePost } = usePosts();
  const [post, setPost] = useState<Post | null>(null);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    loadPost();
  }, [id]);

  const loadPost = async () => {
    if (id) {
      const data = await fetchPostById(id);
      setPost(data);
      setLoading(false);
    }
  };

  const generateSlug = (title: string) => {
    return title
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "");
  };

  const handleSubmit = async (formData: PostFormData, categoryId: string) => {
    setIsLoading(true);
    const slug = generateSlug(formData.title);
    const success = await updatePost(id!, { ...formData, category_id: categoryId, slug });
    setIsLoading(false);
    if (success) {
      navigate(-1);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <PageLayout title="Modifier  un  article" className="min-h-screen bg-gray-50 p-6 max-w-7xl mx-auto">
      <PageContainer>
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Modifier l'article</h1>
          <p className="text-gray-500 mt-1">Modifiez le contenu de l'article</p>
        </div>
        <PostForm initialData={post || undefined} isEdit={true} onSubmit={handleSubmit} isLoading={isLoading} />
      </PageContainer>
    </PageLayout>
  );
}
